import OwnerModel from '../owner/owner-model';

export default class PersonalinfotypeModel {
    id: number;
    name: string;
    description: string;
    status: string;
    type: string;
    typeCaption: string;
    owner: any;
    ownerCaption: string;

    constructor(datarow:any) {
        if (datarow.attributes) datarow = {...datarow.attributes, id: datarow.id}
        this.id = datarow.id;
        this.name = datarow.name;
        this.description = datarow.description;
        this.status = datarow.status || 'active';
        this.type = datarow.type || 'employee';
        this.typeCaption = PersonalinfotypeModel.optionType.filter((d: any) => d.name === this.type)?.[0]?.caption || 'Employee';
        let owner = datarow.owner?.data? new OwnerModel(datarow.owner?.data) : datarow.owner;
        this.owner = owner?.id;
        this.ownerCaption = owner?.name;
        
    } 

    public static endPoint: string = 'personal-info-types';
    public static endPointFilterList = (type?: string) => {
        const owner = OwnerModel.getOwner();
        return ( '?populate=*&sort=name'+ (type? '&filters[type]=' + type : ''));
        return ( '?populate=*&sort=name&filters[owner]=' + owner + (type? '&filters[type]=' +type : ''));
    } 
    public static url: string = '/personalinfotype';
    public static caption: string = 'Personal Info Type';

    public static defaultValue = () => {
        return {
        id: 0,
        name: '',
        description: '',
        status: 'active',
        type: 'employee',
        typeCaption: 'Employee',
        owner: +OwnerModel.getOwner(),
        ownerCaption: OwnerModel.getOwnerCaption(),         
  
        }
    }
    
    public static validations = [
        { name: 'name', required: true, minLength: 3 },
        { name: 'description', minLength: 3 },
    ]

    public static columns = [
        { name: 'name', caption: 'Name' },
        { name: 'description', caption: 'Description' },
        { name: 'status', caption: ' ', type: 'state', default: 'active' },
    ]

    public static columnPicklist = [
        { name: 'name', caption: 'Name' },
        { name: 'description', caption: 'Description' },
    ]

    public static optionStatus = [
        { name: 'active', caption: 'Active' },
        { name: 'inactive', caption: 'Inactive' },
    ]
    
    public static optionType = [
        { name: 'employee', caption: 'Employee' },
        { name: 'customer', caption: 'Customer' },
        { name: 'vendor', caption: 'Vendor' },
    ]
}